import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MenuSection } from "app/models/menu.model";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-changes-for-menus',
  templateUrl: './changes-for-menus.component.html',
  styleUrls: ['./changes-for-menus.component.scss']
})
export class ChangesForMenusComponent implements OnInit {

  @Input() changesInformationMessage: string;
  @Input() currentMenuSectionId: string;
  @Input() menuSections: MenuSection[];
  @Output() menusSelected = new EventEmitter<object>();

  selectedMenuSections = {};
  allMenusChecked = false;

  constructor(private translate: TranslateService) {
  }

  ngOnInit() {
    for (let menuSection of this.menuSections) {
      this.selectedMenuSections[menuSection.id] = menuSection.id === this.currentMenuSectionId;
    }
    this.menusSelected.emit(this.selectedMenuSections);
  }

  setAllMenusChecked(checked: boolean) {
    for (let menuSection of this.menuSections) {
      if (menuSection.id !== this.currentMenuSectionId) {
        this.selectedMenuSections[menuSection.id] = checked;
        this.menusSelected.emit(this.selectedMenuSections);
      }
    }
  }

  menuSelected(menuSectionId: string) {
    this.selectedMenuSections[menuSectionId] = !this.selectedMenuSections[menuSectionId];
    this.menusSelected.emit(this.selectedMenuSections);
  }
}
